import { useState } from 'react';
import { money, qty } from './invApi';

const MV = { reception: 'Réception', work_order: 'Bon de travail', adjustment: 'Ajustement' };
const fmt = (d) => (d ? new Date(d).toLocaleDateString('fr-CA') : '');

const Movements = ({ rows, canSeeCosts }) => (
  <div className="space-y-1">
    {rows.map(m => (
      <div key={m.id} className="flex items-center gap-2 text-xs bg-slate-900 rounded-lg px-3 py-2">
        <span className="text-slate-500 w-20">{fmt(m.created_at)}</span>
        <span className="flex-1 text-slate-300 truncate">{MV[m.type]} {m.order_number || m.invoice_number || m.reason || ''} {m.supplier_name ? `· ${m.supplier_name}` : ''}</span>
        {canSeeCosts && m.type === 'reception' && <span className="text-slate-400">{money(m.unit_cost)}</span>}
        <span className={m.quantity > 0 ? 'text-emerald-400 w-12 text-right' : 'text-red-300 w-12 text-right'}>{m.quantity > 0 ? '+' : ''}{qty(m.quantity)}</span>
      </div>
    ))}
  </div>
);

const Vehicles = ({ rows }) => rows.map((v, i) => (
  <div key={i} className="text-xs bg-slate-900 rounded-lg px-3 py-2 text-slate-300">#{v.vehicle_unit || '?'} {v.vehicle_label} · {v.times} fois · {v.orders.filter(Boolean).join(', ')}</div>
));

const Suppliers = ({ rows, canSeeCosts }) => rows.map((s, i) => (
  <div key={i} className="text-xs bg-slate-900 rounded-lg px-3 py-2 text-slate-300 flex flex-wrap gap-x-4 gap-y-1">
    <span className="text-white font-medium">{s.supplier_name}</span>
    {canSeeCosts && <span>Dernier {money(s.last_cost)} · moyen {money(s.avg_cost)} · {s.purchases} achat(s)</span>}
    <span>Délai {s.avg_lead_days != null ? `${s.avg_lead_days} j` : 'inconnu'}</span>
    {!s.has_account && <span className="text-amber-300">Aucun compte</span>}
    {s.website && <a href={s.website} target="_blank" rel="noreferrer" className="text-sky-400 underline">Site</a>}
  </div>
));

export const ItemHistory = ({ item, canSeeCosts }) => {
  const [tab, setTab] = useState('movements');
  const tabs = [['movements', `Mouvements (${item.movements.length})`], ['vehicles', `Véhicules (${item.vehicles.length})`], ['suppliers', `Fournisseurs (${item.suppliers.length})`]];
  return (
    <div className="space-y-2" data-testid="item-history">
      <div className="flex gap-1">
        {tabs.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`px-3 py-1.5 rounded-full text-xs ${tab === k ? 'bg-amber-500/20 text-amber-300' : 'text-slate-400 hover:text-white'}`} data-testid={`item-history-${k}`}>{l}</button>)}
      </div>
      <div className="max-h-64 overflow-y-auto space-y-1">
        {tab === 'movements' && <Movements rows={item.movements} canSeeCosts={canSeeCosts} />}
        {tab === 'vehicles' && <Vehicles rows={item.vehicles} />}
        {tab === 'suppliers' && <Suppliers rows={item.suppliers} canSeeCosts={canSeeCosts} />}
      </div>
    </div>
  );
};
